import { useForm } from "@mantine/form";
import { Button, Flex, Loader, TextInput, Center } from "@mantine/core";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { getEmployeeById, updateEmployeeById } from "../../api/employeeApi";
import { updateNotification } from "../../utils/useNotification";
import Container from "../common/Container";
import { ActionIcon } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import styled from "styled-components";
import {
  combineValidators, validateMaxLength, validateMinLength,
  validateNoSpaces, validatePhoneNumberIsNumeric,
  validatePhoneNumberStartsWithZero, validateRequired,
} from "../../utils/validations";

const EmployeesUpdateForm = () => {
  const navigate = useNavigate();
  const { id, employeeId } = useParams();
  const [loading, setLoading] = useState(true);

  const form = useForm({
    initialValues: { name: "", phone: "" },
    validate: {
      name: validateRequired,
      phone: combineValidators(
        validateRequired, validatePhoneNumberStartsWithZero,
        validatePhoneNumberIsNumeric, validateNoSpaces,
        validateMinLength(11), validateMaxLength(11)
      ),
    },
  });

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const res: any = await getEmployeeById(employeeId as string);
        const userData = res?.data?.response || res?.data?.data || res?.data;
        if (userData) {
          form.setValues({
            name: userData.name ?? "",
            phone: userData.phone?.startsWith("+90")
              ? "0" + userData.phone.slice(3)
              : userData.phone ?? "",
          });
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };
    if (employeeId) fetchEmployee();
  }, [employeeId]);

  const handleSubmit = async (values: any) => {
    try {
      const { data }: any = await updateEmployeeById({ id: employeeId, updates: values });
      updateNotification(data?.success);
      navigate(`/companies/detail/${id}?tab=employee`)
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (loading) return <Center h={400}><Loader color="#5C26FF" /></Center>;

  return (
    <Container>
      <ActionIcon variant="subtle" color="#5c26ff" size={44} onClick={() => navigate(`/companies/detail/${id}?tab=employee`)}>
        <IconArrowLeft size={28} />
      </ActionIcon>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "70vh"}}>
        <PageTitle><Title>Çalışan Bilgileri Güncelleme</Title></PageTitle>
        <form style={{ display: "flex", flexDirection: "column", gap: "15px", width: "min(468px, 100%)", marginTop: "20px" }}
          onSubmit={form.onSubmit(handleSubmit)}>
          <TextInput label="Ad Soyad" radius={10} size="md" {...form.getInputProps("name")} />
          <TextInput label="Telefon" radius={10} size="md" maxLength={11} {...form.getInputProps("phone")} />
          <Flex gap={10} mt={10}>
            <Button variant="outline" color="gray" radius={10} fullWidth onClick={() => navigate(`/companies/detail/${id}?tab=employee`)}>Vazgeç</Button>
            <Button color="#5C26FF" radius={10} type="submit" fullWidth disabled={!form.isDirty()}>Güncelle</Button>
          </Flex>
        </form>
      </div>
    </Container>
  );
};

export default EmployeesUpdateForm;

const PageTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 12px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  color: black;
`;